/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  LogSearch,
  ErrorInfo,
  LogSearchConditions,
  BinaryFile,
  PostLogsDownloadBody
} from '.././model'


/**
 * S3のログフォルダの情報を取得する。

 * @summary ログ検索
 */
export const postLogsSearch = (
    logSearchConditions: LogSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LogSearch>> => {
    return axios.post(
      `/logs/search`,
      logSearchConditions,options
    );
  }



    export type PostLogsSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postLogsSearch>>>
    export type PostLogsSearchMutationBody = LogSearchConditions
    export type PostLogsSearchMutationError = AxiosError<ErrorInfo>

    export const usePostLogsSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLogsSearch>>, TError,{data: LogSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLogsSearch>>, {data: LogSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postLogsSearch(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postLogsSearch>>, TError, {data: LogSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ログダウンロード

 * @summary ログダウンロード
 */
export const postLogsDownload = (
    postLogsDownloadBody: PostLogsDownloadBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/logs/download`,
      postLogsDownloadBody,options
    );
  }



    export type PostLogsDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postLogsDownload>>>
    export type PostLogsDownloadMutationBody = PostLogsDownloadBody
    export type PostLogsDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostLogsDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLogsDownload>>, TError,{data: PostLogsDownloadBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLogsDownload>>, {data: PostLogsDownloadBody}> = (props) => {
          const {data} = props ?? {};

          return  postLogsDownload(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postLogsDownload>>, TError, {data: PostLogsDownloadBody}, TContext>(mutationFn, mutationOptions)
    }
    